import type { AuthorizationConfig } from '@tbitop/authorization';
import type { StageParameters } from '../../stage/stage-parameters';

export type AuthorizationEnvSetting = ReturnType<typeof getAuthorizationConfig>;

type AuthorizationConfigParams =
  Omit<AuthorizationConfig, 'requiredRoles'> &
  Partial<Pick<AuthorizationConfig, 'requiredRoles'>>;

export const getAuthorizationConfig = (
  _: StageParameters,
  { resourceName, requiredRoles = [] }: AuthorizationConfigParams,
): AuthorizationConfig => ({
  resourceName,
  requiredRoles,
});

